module.exports = __webpack_public_path__ + "595098f35b8873877a9edfe834f0aa5a.png";